import lazyImporter from '@/utils/lazyImporter'

const profileRoute = {
  component: lazyImporter('View'),
  meta: { title: 'profile', hidden: true },
  name: 'admin_profile',
  path: '/profile',
  redirect: { name: 'admin_profile_edit' },
  children: [
    {
      component: lazyImporter('profile/ProfileUpdate'),
      meta: { title: 'profileEdit' },
      name: 'admin_profile_edit',
      path: 'edit',
      redirect: { name: 'admin_profile_edit_details' },
      children: [
        {
          meta: { title: 'profilePassword' },
          name: 'admin_profile_edit_password',
          path: 'password'
        },
        {
          meta: { title: 'profileDetails' },
          name: 'admin_profile_edit_details',
          path: 'details'
        }
      ]
    }
  ]
}

export default profileRoute
